import { useQuery } from "react-query";
import { getFileCategoryList } from "../../../../../actions/Utilities/FileCategory";

export default function useGetFileCategoryList() {
  return useQuery("GetFileCategory", getFileCategoryList, {
    refetchOnWindowFocus: false,
  });
}
